import { authorLinkIcon } from "@/helpers/author";

export default {
  name: "author-hero",
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  methods: {
    linkIcon(type) {
      return authorLinkIcon(type);
    },
  },
};
